var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36911 12.67H4.23867L9.94882 6.95586L9.07926 6.08631L3.36911 11.8004V12.67ZM12.8825 5.99318L10.0293 3.16928L10.851 2.34355C11.1437 2.04814 11.5001 1.89977 11.9202 1.89845C12.3402 1.89711 12.698 2.04282 12.9934 2.33558L13.7872 3.12941C14.064 3.40091 14.204 3.72453 14.2072 4.10025C14.2103 4.47598 14.0788 4.79694 13.8126 5.06311L12.8825 5.99318ZM11.9198 6.97253L4.82926 14.0631H1.97201V11.2098L9.06259 4.11928L11.9198 6.97253ZM9.51802 6.52108L9.07926 6.08631L9.94882 6.95586L9.51802 6.52108Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileEditIcon);
export default __webpack_public_path__ + "static/media/MobileEditIcon.ac39b28191c059b52fbe524bad1fde9f.svg";
export { ForwardRef as ReactComponent };